export default __webpack_public_path__ + "static/media/Samsung Galaxy S8+.bde2cff1.png";